import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel, { type InputLabelProps } from '@mui/material/InputLabel';
import FormHelperText, { type FormHelperTextProps } from '@mui/material/FormHelperText';
import TextareaAutosize, { type TextareaAutosizeProps } from '@mui/material/TextareaAutosize';
import clsx from 'clsx';

import './TextArea.scss';

interface TextAreaProps extends TextareaAutosizeProps {
    label?: React.ReactNode | string;
    InputLabelProps?: InputLabelProps;
    helperText?: React.ReactNode;
    helperTextId?: string;
    FormHelperTextProps?: FormHelperTextProps;
    className?: string;
    fullWidth?: boolean;
    error?: boolean;
}

export const TextArea = React.forwardRef<any, TextAreaProps>((props, ref) => {
    const { 
        label, 
        InputLabelProps, 
        className, 
        disabled, 
        helperText, 
        helperTextId,
        FormHelperTextProps, 
        fullWidth, 
        error, 
        readOnly, 
        style,
        ...rest 
    } = props;

    return (
        <FormControl 
            ref={ref}
            disabled={disabled}
            error={error}
            fullWidth={fullWidth}
            className={clsx('ms_textarea', readOnly && 'readonly', className)}
            variant="filled"
            style={style}
        >
            {label && <InputLabel {...InputLabelProps}>{label}</InputLabel>}
            <TextareaAutosize
                className="ms-textarea-input"
                disabled={disabled}
                readOnly={readOnly}
                {...rest}
            />
            {helperText && (
                <FormHelperText id={helperTextId} {...FormHelperTextProps}>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
});